import { LegalEntitySelector } from './LegalEntitySelector';

interface ShipperSelectorProps {
  value?: string;
  onChange?: (value: string) => void;
}

export const ShipperSelector = ({ value, onChange }: ShipperSelectorProps) => (
  <LegalEntitySelector
    value={value}
    onChange={onChange}
    placeholder='Select shipper'
    addNewLabel='Add New Shipper'
    modalTitle='Add New Shipper'
    addressType='PICK_UP'
  />
);
